<template>
	<div class="id">

		<van-nav-bar :title="title" class="nav-bar" left-arrow @click-left="back()">
		</van-nav-bar>

		<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :show-indicators="false">
			<van-swipe-item v-for="(item, index) in objData.order_list_banner" :key="index">
				<img :src="item" />
			</van-swipe-item>
		</van-swipe>
		<div class="swiper-title">{{ objData.order_title }}</div>

		<div class="contentBox">
			<div class="contentText">
				<div class="item" @click="type = 1"> {{ $t('textS10') }} </div>
				<div class="item" @click="type = 2"> {{ $t('textS11') }} </div>
			</div>
			<div v-if="type == 1" class="contentData">
				<div class="itemData">
					<div>{{ $t('textS12') }}</div>
					<div>{{ objS.money }}</div>
				</div>
				<div class="itemData">
					<div>{{ $t('textS13') }}</div>
					<div>{{ objS.today_commission }}</div>
				</div>
				<div class="itemData">
					<div>{{ $t('textS14') }}</div>
					<div>{{ objS.completed }}/{{ objS.all }}</div>
				</div>
				<div class="itemData">
					<div>{{ $t('textS15') }}</div>
					<div>{{ objS.commission }}</div>
				</div>
			</div>
			<div v-if="type == 2" style="padding: 20px 0;">{{ objS.rule }}</div>
			<div class="GrabOrder" @click="grabOrder">{{ $t('textS16') }}</div>
		</div>

		<div class="shuadanBtm">
			<!-- <div class="text">{{$t('textS17')}}</div> -->
			<div class="masonry">
				<div v-for="item in objData.hotel" :key="item.id" class="masonry-item">
					<img style="width: 100%;display: block;" :src="item.image" />
				</div>
			</div>
		</div>

		<!-- <div class="shuadanBtm">
			<div class="text">{{$t('textS17')}}</div>
			<div class="masonry">
				<div v-for="item in objData.beauty" :key="item.id" class="masonry-item"
					@click="$router.push({path:'/concubineDetails',query: {id:item.id}});">
					<img style="width: 100%;display: block;" :src="item.image" />
				</div>
			</div>
		</div> -->

		<van-popup v-model="show" round>
			<div v-if="objItem.goodsList" style="width: 370px;padding: 10px;">
				<img style="width: 100%;object-fit: cover;" :src="objItem.goodsList.image" />
				<div class="btn" @click="submit">{{ $t('setting.ok') }}</div>
				<div class="boxDetails">
					<div class="item">{{ $t('setting.name') }}：{{ objItem.goodsList.title }}</div>
					<div class="item">{{ $t('textS18') }}：{{ objItem.goods_prices }}</div>
					<div class="item">{{ $t('textS19') }}：{{ objItem.goods_number }}</div>
					<div class="item">{{ $t('textS20') }}：{{ objItem.commission }}</div>
					<div class="item">{{ $t('other.order_number') }}：{{ objItem.order_sn }}</div>
					<div class="item">{{ $t('withdraw.submit_time') }}：{{ objItem.createtime_text }}</div>
				</div>
			</div>
		</van-popup>

		<van-popup v-model="msgShow" round>
			<div style="width: 370px;padding: 20px">
				<div style="font-size: 20px;">{{ msgW }}</div>
				<!-- 	<div class="btcS" @click="msgShow=false">{{$t('setting.cancel')}}</div> -->
			</div>
		</van-popup>
	</div>
</template>

<script>
export default {
	data() {
		return {
			type: 1,
			objData: {},
			objS: {},
			show: false,
			msgShow: false,
			msgW: '',
			objItem: {},
			title: '',
		};
	},
	created() {
		this.getOrderData()
		this.getUserOrderInfo()
		this.title = this.$route.query.title || ''
	},
	computed: {},
	methods: {
		back() {
			this.$router.back()
		},
		submit() {
			this.$http({
				method: "post",
				url: "completeOrder",
				data: {
					order_id: this.objItem.id
				}
			}).then((res) => {
				if (res.code == 203) {
					// this.show = false
					this.msgW = res.msg
					this.msgShow = true
					return
				}
				if (res.code == 1) {
					this.$toast(res.msg);
					this.show = false
					this.getUserOrderInfo()
				} else {
					this.$toast(res.msg);
				}
			});
		},

		//点击按钮
		grabOrder() {
			this.$http({
				method: "post",
				url: "createOrder",
			}).then((res) => {
				console.log(res.code)
				if (res.code == 1) {
					console.log(res.data)
					this.objItem = res.data
					this.show = true
				} else {
					this.$toast(res.msg);
				}
			});
		},


		//投票
		getOrderData() {
			this.$http({
				method: "get",
				url: "getOrderData",
			}).then((res) => {
				if (res.code == 1) {
					console.log(res.data)
					this.objData = res.data;
					// this.sidebarS(res.data[0].id)
				} else {
					this.$toast(res.msg);
				}
			});
		},
		getUserOrderInfo() {
			this.$http({
				method: "get",
				url: "getUserOrderInfo",
			}).then((res) => {
				if (res.code == 1) {
					console.log(res.data)
					this.objS = res.data;
				} else {
					this.$toast(res.msg);
				}
			});
		}

	},
};
</script>

<style lang="less" scoped>
.nav-bar {
	background: linear-gradient(90deg, #f905e5, #e6c3a1);

	/deep/.van-icon {
		color: #fff !important;
	}
}

.btcS {
	width: 100%;
	background: linear-gradient(#fe5986, #ff848b);
	color: #fff;
	border-radius: 10px;
	margin-top: 30px;
	border: 0 solid #000;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.boxDetails {
	text-align: left;
	padding: 20px;

	.item {
		padding: 12px 0;
	}
}

.id {
	position: relative;

	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		height: 400px;
		text-align: center;
		background-color: #39a9ed;
	}

	.swiper-title {
		position: absolute;
		top: 300px;
		left: 0;
		padding: 20px;
		z-index: 1000000;
	}
}

.contentBox {
	background: linear-gradient(90deg, #df35ad, #4f1db5);
	margin: 20px;
	border-radius: 15px;
	overflow: hidden;
	padding: 30px;
	color: #fff;

	.contentText {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #fff;

		.item {
			padding: 0 10px 20px 10px;
		}
	}

	.contentData {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		text-align: center;

		.itemData {
			width: 50%;
			padding: 20px;
		}

		.itemData :first-child {
			padding-bottom: 16px;
		}
	}

	.GrabOrder {
		width: 100%;
		background: linear-gradient(#fe5986, #ff848b);
		color: #fff;
		border-radius: 10px;
		margin-top: 20px;
		border: 0 solid #000;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.btn {
	margin-top: 10px;
	width: 96%;
	background: linear-gradient(#fe5986, #ff848b);
	color: #fff;
	border-radius: 7.5px;
	border: 0 solid #000;
	display: flex;
	padding: 20px 0;
	align-items: center;
	justify-content: center;
	margin-left: 2%;
}

.shuadanBtm {
	padding: 16px;
	padding-bottom: 140px;

	.text {
		color: #4f1db5;
		text-align: center;
		font-weight: 700;
	}

	.masonry {
		-moz-column-count: 2;
		column-count: 2;
		-moz-column-gap: 10px;
		column-gap: 10px;
		padding: 20px;

		.masonry-item {
			-moz-column-break-inside: avoid;
			break-inside: avoid;
			margin-bottom: 20px;
			background: #fff;
			border-radius: 10px;
			overflow: hidden;
			box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
		}
	}
}
</style>